import { call } from 'redux-saga/effects'
import * as JD from 'domain/manager/jobDrafts'

export function* jobDraftView() {
  yield call(JD.ensureGetManagerJobDraft)
}
